const mutations = {
    get_VWelcomeText(state, data) {
        state.TextVwelcome = data
    },
    get_Shootingbook(state, data) {
        state.Shootingbook = data
    },
    get_ShootingbookApproval(state, data) {
        state.ShootingbookApproval = data
    },
    get_TodayMember(state, data) {
        state.TodayMember = data
    },
    get_TodaySA(state, data) {
        state.TodaySA = data
    },
    get_TodaySL(state, data) {
        state.TodaySL = data
    },
    get_ClubMember(state, data) {
        state.ClubMember = data
    },
    get_Verband(state, {VerbandAll, VerbandOwn}) {
        state.VerbandAll = VerbandAll,
            state.VerbandOwn = VerbandOwn
    },
    get_shootingrange(state, data) {
        state.ShootingRanges = data
    },
    get_Weapons(state, data) {
        state.Weapons = data
    },
    get_Terminals(state, data) {
        state.Terminals = data
    },
    set_WorkingHours(state, data){
        state.WorkingHours = data
    },
    set_client_terminal_telemetries(state, data){
        state.client_terminal_telemetries = data
    },
    CLEAR_CLIENT_TELEMETRY(state){
        state.client_terminal_telemetries = []
    },
    set_client_terminal_rfidlogs(state, data){
        state.client_terminal_rfid_logs = data
    },
    CLEAR_CLIENT_TERMINAL_RFIDLOGS(state){
        state.client_terminal_rfid_logs = []
    },

    set_appDataClear(state) {
        state.TextVwelcome = "",
            state.Shootingbook = [],
            state.ShootingbookApproval = [],
            state.TodayMember = [],
            state.TodaySA = [],
            state.TodaySL = [],
            state.ClubMember = [],
            state.VerbandAll = [],
            state.VerbandOwn = [],
            state.ShootingRanges = [],
            state.Weapons = [],
            state.Terminals = [],
            state.WorkingHours = [],
            state.client_terminal_telemetries = [],
            state.client_terminal_rfid_logs = [];
        state.WeaponPool = [];
        state.WeaponPoolStatistics = null;
        state.WeaponPoolShowOnlyActive = false;
        state.ArbeitsstundenAuswertung = [];
        state.ArbeitsstundenFreigaben = [];
        state.Arbeitseinsaetze = [];
        state.Beitragsgruppen = [];
        state.BeitragsgruppeMembers = [];
        state.ArbeitsstundenFunctions = [];
    },
    SET_CLUB_WEAPON_POOL(state, data) {
        state.WeaponPool = data;
    },
    SET_CLUB_WEAPON_POOL_STATISTICS(state, data) {
        state.WeaponPoolStatistics = data;
    },
    SET_WEAPON_POOL_SHOW_ONLY_ACTIVE(state, data) {
        state.WeaponPoolShowOnlyActive = data;
    },
    SET_ARBEITSSTUNDEN_AUSWERTUNG(state, data) {
        state.ArbeitsstundenAuswertung = data;
    },
    SET_ARBEITSSTUNDEN_FREIGABEN(state, data) {
        state.ArbeitsstundenFreigaben = data;
    },
    SET_ARBEITSEINSAETZE(state, data) {
        state.Arbeitseinsaetze = data;
    },
    SET_BEITRAGSGRUPPEN(state, data) {
        state.Beitragsgruppen = data;
    },
    SET_BEITRAGSGRUPPE_MEMBERS(state, data) {
        state.BeitragsgruppeMembers = data;
    },
    SET_ARBEITSSTUNDEN_FUNCTIONS(state, data) {
        state.ArbeitsstundenFunctions = data;
    },
    SET_ARBEITSEINSATZ_TEILNEHMER(state, data) {
        state.ArbeitseinsatzTeilnehmer = data;
    }
};

export default mutations;
